const apiEndpoint = process.env.REACT_APP_API_URL;
export const BASE_URL = process.env.REACT_APP_BASE || "http://3.224.229.28/";
export const ONBOARDING_FORM = process.env.REACT_APP_ONBOARDING_FORM;
export default apiEndpoint;